<template>
    <div ref="request_report_detail_wrap" style="display: flex; flex-direction: column; background-color: #fffc; backdrop-filter: blur(100px);">
        <MercenaryHeader :isBlur="true" backgroundColor="#fffc" :title="'요청서 리포트'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div v-if="showContents" style="flex: 1; padding: 0 12px; overflow-y: scroll;">
            <div style="margin-top: 20px;">
                <div style="background: #210F031A; border-radius: 12px; padding: 20px; text-align: center;">
                    <img v-if="directMessage.team && directMessage.team.image_path" style="width: 80px;" :src="$resourcePath + directMessage.team.image_path" alt="">
                    <div style="color: #B5AAA3; font-size: 12px; font-weight: 700; ">{{ directMessage.team && directMessage.team.name ? directMessage.team.name : '' }}</div>
                    <div style="margin-top: 20px; line-height: 24px; font-weight: 500;">
                        <span style="font-weight: 700;">{{ directMessage.team && directMessage.team.name ? directMessage.team.name : '' }},
                            {{ directMessage.team && directMessage.team.manager ? directMessage.team.manager.nic_name : '' }}</span>감독님에게 전달됐습니다
                    </div>
                    <div style="font-size: 14px;font-weight: 500;line-height: 24px; color: #606060; margin-top: 4px;">{{ $Util.getYYYYDotMMDotDDDayStr(directMessage.insert_date) }}</div>
                    <template>
                        <div style="background-color: rgba(33, 15, 3, 0.1); height:1px; margin:20px 0px;"></div>
                        <div style="font-size:14px; font-weight:bold;  display:flex; justify-content: center; align-items: center;" @click="() => { if (isEnableTopUpdate) showLastTopUpdateBookmark(); }">
                            <template v-if="isEnableTopUpdate">
                                <img :src="require('@/assets/img/transfer_btn_on.png')" style="width:12px; height:12px;">
                                <span style="color:var(--color-main);margin-left:5px;">요청서 다시 보내기</span>
                            </template>
                            <template v-else>
                                <img :src="require('@/assets/img/transfer_btn_off.png')" style="width:12px; height:12px;">
                                <span style="color:#BBBBBB;margin-left:5px;">요청서 다시 보내기</span>
                            </template>
                        </div>
                    </template>

                </div>
            </div>
            <div style="margin-top: 20px;">
                <div style="background: #210F031A; padding: 12px; border-radius: 12px;">
                    <div v-if="directMessage.status < DIRECT_MESSAGE_STATUS.COACH_CHECKED" style="text-align: center; font-size: 14px; line-height: 24px; font-weight: 500;">📫 아직 읽지 않음</div>
                    <div v-else style="text-align: center;">
                        <div style="font-size: 14px; line-height: 24px; font-weight: 500;">📭 읽음!</div>
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px; font-size: 14px; color: #606060;">{{ directMessage.check_date | agoDateStr }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="font-weight: 700; margin-bottom: 12px;">입단 서포터</div>
                <div style="background: #210F031A; padding: 12px; border-radius: 12px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-bottom: 8px;">담당자</div>
                    <div v-if="!directMessage.supporter" style="font-size: 12px; font-weight: 700; line-height: 24px; color: #808080;">아직 담당자가 없어요</div>
                    <!-- <div v-if="!directMessage.supporter" style="font-size: 12px; font-weight: 700; line-height: 24px; color: #808080;">아직 담당자가 없어요</div> -->
                    <div v-else>
                        <div style="display: flex; align-items: start; gap: 8px;">
                            <ProfileImage style="width: 40px;"></ProfileImage>
                            <div>
                                <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ directMessage.supporter.name }}</div>
                                <div style="font-weight: 500; font-size: 14px; line-height: 24px; white-space: pre-wrap">{{ directMessage.introduce }}</div>
                            </div>
                        </div>
                        <div @click="showChat" style="height: 44px; line-height: 44px; text-align: center; border-radius: 12px; background-color: var(--color-main); margin-top: 20px; font-size: 14px; font-weight: 700;">문의하기</div>
                        <div v-if="last_chat_contents" style="margin-top: 20px;">
                            <div style="font-weight: 700; font-size: 12px; line-height: 24px;">최근 메시지</div>
                            <div style="display: flex; align-items: center; gap: 8px; margin-top: 8px; position: relative;">
                                <ProfileImage style="width: 40px;"></ProfileImage>
                                <div>
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">{{ directMessage.supporter.name }}</div>
                                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">{{ last_chat_contents.contents }}</div>
                                </div>
                                <div style="position: absolute; display: flex; right: 0; top: 0; gap: 8px;">
                                    <div style="font-size: 12px; font-weight: 500; line-height: 20px;">{{ last_chat_contents.insert_date | agoDateStr }}</div>
                                    <div>
                                        <img style="transform: rotate(90deg); width: 10px;" :src="require('@/assets/img/arrow_gray.png')" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="directMessage.is_skip == 0" style="background: #210F031A; padding: 12px; border-radius: 12px; margin-top: 12px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-bottom: 8px;">진행 현황</div>
                    <div style="margin-top: 20px; margin-bottom: 30px">
                        <div style="background: #FFFFFF66; height: 4px; border-radius: 2px; display: flex;;">
                            <div :class="requestStatus >= 0 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 13.5%;">
                                <div :class="requestStatus >= 0 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 0 ? 'circle_text_active' : ''" class="circle_text">요청서 전달</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= 1 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 20.5%;">
                                <div :class="requestStatus >= 1 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 1 ? 'circle_text_active' : ''" class="circle_text">감독 확인</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= 2 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 20.5%;">
                                <div :class="requestStatus >= 2 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 2 ? 'circle_text_active' : ''" class="circle_text">감독 수락</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= 3 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 27%;">
                                <div :class="requestStatus >= 3 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 3 ? 'circle_text_active' : ''" class="circle_text">입단 테스트 일정 잡기</div>
                                    <div v-if="directMessage.test_date" style="top: 36px; color: var(--color-main); font-weight: 700; font-size: 14px;" class="circle_text">{{ transDate(directMessage.test_date) }}</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= 4 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex: 1;"></div>
                        </div>
                        <div style="background: #FFFFFF66; height: 4px; border-radius: 2px; display: flex; margin-top: 55px; max-width: 135px;">
                            <div :class="requestStatus >= 4 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 45%;">
                                <div :class="requestStatus >= 4 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 4 ? 'circle_text_active' : ''" class="circle_text">입단 테스트 진행</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= 5 ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex: 1;">
                                <div :class="requestStatus >= 5 ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= 5 ? 'circle_text_active' : ''" class="circle_text">결과 안내</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else style="margin-top: 12px;">
                    <div style="background: #FF11111A; padding: 12px; border-radius: 12px;">
                        <div style="color: #FF1111; font-weight: 700; line-height: 24px; text-align: center;">📢 아쉽지만 매칭이 되지 않았습니다.</div>
                    </div>
                    <div v-if="directMessage.feedback" style="margin-top: 40px;">
                        <div style="font-weight: 700; margin-bottom: 10px;">도착한 피드백</div>
                        <div style="font-weight: 500; font-size: 14px; color: #808080;">감독님이 회원님께 전하는 응원의 조언입니다.</div>
                        <div style="background: #210F031A; padding: 12px; border-radius: 12px; margin-top: 12px;">
                            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ directMessage.feedback }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px;">
                <div style="font-weight: 700; margin-bottom: 10px;">내 요청서 조회 현황</div>
                <div style="font-weight: 500; font-size: 14px; color: #808080;">지금까지 내 요청서를 본 모든 회원들입니다</div>
                <div style="background: #210F031A; padding: 20px; border-radius: 12px; margin-top: 12px; display: flex; justify-content: space-around;">
                    <div style="text-align: center;">
                        <div style="font-weight: 500; font-size: 12px; line-height: 18px; margin-bottom: 4px; color: #606060;">일반 회원</div>
                        <div style="font-weight: 700; line-height: 24px;">{{ normalCnt }}명</div>
                    </div>
                    <div style="text-align: center;">
                        <div style="font-weight: 500; font-size: 12px; line-height: 18px; margin-bottom: 4px; color: #606060;">전문가 회원</div>
                        <div style="font-weight: 700; line-height: 24px;">{{ coachCnt }}명</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 40px; padding-bottom: 40px;">
                <div style="font-weight: 700; margin-bottom: 10px;">경쟁중인 선수</div>
                <div style="font-weight: 500; font-size: 14px; color: #808080;">감독님이 관심 가지고 있거나 직접 요청서를 보낸 선수들입니다</div>
                <div style="">
                    <div style="overflow-x: scroll; display: flex; gap: 16px; margin: 0 -12px; padding: 0 12px; overflow-y: hidden;" class="hide_scroll">
                        <div v-for="each, i in interestMembers" :key="i + 'interest'" style="display: flex; gap: 16px;">
                            <div style="position: relative;  margin-top: 14px;">
                                <div :style="{ opacity: each.is_like == 1 ? '1' : '0' }" style="text-align: center; margin-bottom: 6px;">
                                    <img style="width: 16px;" :src="require('@/assets/img/player_star.png')" alt="">
                                </div>
                                <div @click="$Util.showProfile(each.idx)">
                                    <ProfileImage :imagePath="each.image_path" style="width: 100px;"></ProfileImage>
                                </div>
                                <div style="display: flex; justify-content: center; margin-top: 4px; gap: 4px;">
                                    <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ each.nic_name }}</div>
                                    <div style="font-weight: 900; font-size: 11px; color: var(--color-main); line-height: 16px;">
                                        <DivisionPositionText :position="each.position" :positionProAbility="each.position_pro_ability"></DivisionPositionText>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BookmarkPopup :background="'#fff'" :height="340" :isShowBookmarkPopup="isShowBoomarkForLastTopUpdate" :closeBookmarkPopup="() => { isShowBoomarkForLastTopUpdate = false }">
            <div>
                <div @click="() => { isShowBoomarkForLastTopUpdate }" style="font-weight: 700;">닫기</div>
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 12px;">게시물을 신고할까요?</div>
                    <div style="margin-top: 20px; color: #606060; font-weight: 500; line-height: 24px;">하루에 한 번씩 딱 한 명의 감독님에게 다이렉트 요청서를 다시 보낼 수 있습니다. 요청서를 다시 보낼 경우 감독님에게 알림이 다시 전송되며, 요청이 거절되어도 다시 보낼 수 있습니다. 다이렉트 요청서를 다시 보낼까요?</div>
                    <div @click="updateLastTopDate" style="width: 210px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">요청서 다시 보내기</div>
                </div>
            </div>
        </BookmarkPopup>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import { DIRECT_MESSAGE_STATUS, JOIN_CHAT_TYPE, MEMBER_TYPE } from "../../Constants";
import ResponseCode from "../../ResponseCode";
import BookmarkPopup from "./BookmarkPopup";
import moment from 'moment'
import DivisionPositionText from '@/components/common/DivisionPositionText'

export default {
    name: 'RequestReportDetail',
    components: { BookmarkPopup, MercenaryHeader, ProfileImage, DivisionPositionText },
    props: {
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        direct_message_idx: {
            type: [Number, String],
            default: -1
        }
    },
    mounted(){
        this.$refs.request_report_detail_wrap.parentElement.style.zIndex = 301;
    },
    created() {
        this.updateLastTopDate = this.$Once(this.updateLastTopDate);
        this.getReportDetail()
    },
    data() {
        return {
            // reportDetail: {},
            DIRECT_MESSAGE_STATUS: DIRECT_MESSAGE_STATUS,
            directMessage: {},
            showContents: false,
            normalCnt: 0,
            coachCnt: 0,
            interestMembers: [],
            last_chat_contents: {},
            requestStatus: 0,
            isEnableTopUpdate: false,
            isShowBoomarkForLastTopUpdate: false
        }
    },
    methods: {
        transDate(testDate) {
            const m = moment(testDate).locale('ko');
            const base = m.format('YY.MM.DD(ddd)HH시');
            const minutes = m.minutes();
            return minutes === 0 ? base : `${base}${m.format('mm')}분`;
        },
        showLastTopUpdateBookmark() {
            this.isShowBoomarkForLastTopUpdate = true;
        },
        async updateLastTopDate() {
            this.isShowBoomarkForLastTopUpdate = false;

            const parameters = {};
            parameters.direct_message_idx = this.directMessage.idx;

            const res = await this.$Axios.post('/api/soccerhow/reporting/last_top/update', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.isEnableTopUpdate = false;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        showChat() {
            if (!this.directMessage.supporter) {
                return;
            }

            this.$Axios.showPersonalChat(this.directMessage.supporter.idx, MEMBER_TYPE.USER, JOIN_CHAT_TYPE.SINGLE);

            // this.$Util.showChatWithAdmin();
        },
        async getChatHistory() {
            const parameters = {}
            parameters.opponent_member_idx = this.directMessage.supporter_idx
            // parameters.member_idx = this.directMessage.from_member_idx
            parameters.is_opponent_chat = true

            const res = await this.$Axios.get('/api/chat/last/withtarget', { params: parameters });
            this.last_chat_contents = res.data.last_chat_contents;
        },
        async getReportDetail() {
            const parameters = {}
            parameters.soccerhow_idx = this.soccerhowIdx;
            if (this.direct_message_idx != -1) {
                parameters.direct_message_idx = this.direct_message_idx;
            }

            const res = await this.$Axios.get('/api/soccerhow/reporting', { params: parameters })
            // const reportDetail = res.data.direct_message.team
            const directMessage = res.data.direct_message
            const normalCnt = res.data.normal_cnt
            const coachCnt = res.data.coach_cnt
            const interestMembers = res.data.interest_members
            const requestStatus = parseInt(directMessage.status)

            this.requestStatus = requestStatus
            this.interestMembers = interestMembers
            this.normalCnt = normalCnt
            this.coachCnt = coachCnt
            // this.reportDetail = reportDetail
            this.directMessage = directMessage
            this.showContents = true
            this.getChatHistory()

            if (res.data.request_to_coach_count == 0) {
                this.isEnableTopUpdate = true;
            }
        }
    }
}
</script>

<style scoped>
.circle_wrap {
    border-radius: 2px;
}

.circle_text {
    position: absolute;
    white-space: nowrap;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    left: 50%;
    transform: translateX(-50%);
    top: 22px;
    color: #808080;
}

.circle_text_active {
    top: 18px;
    color: #210f03;
}

.inner_circle {
    width: 20px;
    height: 20px;
    position: relative;
    border-radius: 50%;
    margin-left: auto;
    transform: translateY(-8px);
    background-color: #bbbbbb;
}

.inner_circle_active {
    border: 4px solid #DF5A00;
    background-color: var(--color-main);
}

.circle_wrap_active {
    background-color: var(--color-main);
}

.status-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px 0;
    position: relative;
}

.steps-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 20px;
    width: 100%;
    max-width: 800px;
    position: relative;
}

.step {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    white-space: nowrap;
}

.circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #ccc;
    border: 3px solid #ddd;
    transition: 0.3s;
}

.step.active .circle {
    background: orange;
    border-color: orange;
}

.step span {
    margin-top: 5px;
    font-size: 14px;
}

/* 전체 진행 바 */
.progress-line {
    position: absolute;
    top: 40px;
    left: 0;
    height: 4px;
    transition: width 0.3s;
}

/* 전체 선 (배경) */
.progress-line.full {
    width: 100%;
    background: #ddd;
}

/* 진행된 부분만 칠해짐 */
.progress-line.filled {
    background: orange;
}
</style>